import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function SvgIcon(_theme: Theme) {
    return {
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    '&.MuiSelect-icon': {
                        right: 'auto',
                        insetInlineEnd: 7,
                    },
                },
                fontSizeLarge: {
                    width: 32,
                    height: 32,
                    fontSize: 'inherit',
                },
            },
        },
    };
}
